function frequencyToNoteName(freq) {
  if (freq <= 0) return null;

  const A4 = 440;
  const SEMITONE_RATIO = Math.pow(2, 1/12);
  const NOTES = ["C", "C#", "D", "Eb", "E", "F", "F#", "G", "Ab", "A", "Bb", "B"];

  // Calculate how many semitones away from A4
  const semitonesFromA4 = 12 * Math.log2(freq / A4);
  const nearestSemitone = Math.round(semitonesFromA4);

  const noteIndex = (nearestSemitone + 9) % 12; // because A is index 9
  const octave = 4 + Math.floor((nearestSemitone + 9) / 12);

  const noteName = NOTES[(noteIndex + 12) % 12] + octave;

  // Cents difference
  const exactFreq = A4 * Math.pow(SEMITONE_RATIO, nearestSemitone);
  const cents = Math.floor(1200 * Math.log2(freq / exactFreq));

  return `${noteName} ${cents >= 0 ? "+" : ""}${cents} c`;
}

/******************************************************************
 *  HIGH-RESOLUTION FFT HELPERS  (add above your classes)
 ******************************************************************/
function hannWindow(buf) {
  const N = buf.length;
  for (let i = 0; i < N; i++) {
    buf[i] *= 0.5 * (1 - Math.cos((2 * Math.PI * i) / (N - 1)));  // Hann
  }
}

function interpolatePeak(mag, k) {
  const a = mag[k - 1] || 0, b = mag[k], c = mag[k + 1] || 0;
  const denom = a - 2 * b + c;
  const offs  = denom === 0 ? 0 : 0.5 * (a - c) / denom;
  return k + offs;                 // sub-bin peak position
}

/**  Core analyser: returns [{frequency, amplitude}] for each hop */
function processFFT(signal, fs, fftSize = 8192, hop = 2048) {
  const fft  = new FFT(fftSize, fs);
  const win  = new Float32Array(fftSize);
  const out  = [];

  for (let start = 0; start + fftSize <= signal.length; start += hop) {
    win.fill(0);
    win.set(signal.subarray(start, start + fftSize));  // zero-padding
    hannWindow(win);                                   // taper
    fft.forward(win);

    // strongest bin & sub-bin interpolation
    let k = 0, max = 0;
    for (let i = 1; i < fft.spectrum.length - 1; i++) {
      if (fft.spectrum[i] > max) { max = fft.spectrum[i]; k = i; }
    }
    const pBin = interpolatePeak(fft.spectrum, k);
    const freq = pBin * fs / fftSize;
    out.push({frequency: freq, amplitude: max});
  }
  return out;
}
document.addEventListener("DOMContentLoaded", () => {
  const UIConfig = {
    LEFT_PADDING: 50,
    BOTTOM_PADDING: 20,
    BACKGROUND_COLOR: "#000",
    TEXT_COLOR: "white",
    BUTTON_TEXT_COLOR: "white",
    BUTTON_FONT: "16px Arial",
    LABEL_FONT: "14px Arial",
    AXIS_FONT: "10px Arial",
    FREQUENCY_FONT: "12px Arial",
    /*
    transportButtons: [
      { x: 10,  y: 10,  width: 80, height: 40, color: "orange", text: "Load",   action: "load" },
      { x: 110, y: 10,  width: 80, height: 40, color: "red",    text: "Record", action: "record" },
      { x: 210, y: 10,  width: 80, height: 40, color: "green",  text: "Play",   action: "play"   },
      { x: 310, y: 10,  width: 80, height: 40, color: "black",  text: "Stop",   action: "stop"   },
      { x: 410, y: 10,  width: 80, height: 40, color: "blue",   text: "Freq Gen", action: "frequencyGenerator" }
    ]
    */
  };

  class UIController {
    constructor() {
      this.openButton = document.getElementById("open-button");
      this.playButton = document.getElementById("play-button");
      this.stopButton = document.getElementById("stop-button");
      this.recordButton = document.getElementById("record-button");
      this.saveButton = document.getElementById("save-button");
      this.fileInput = document.getElementById("file-input");
      this.audioInputSelect = document.getElementById("audio-input-select");
      this.channelSelect = document.getElementById("channel-select");
      this.fileNameDisplay = document.getElementById("file-name");
      this.statusDisplay = document.getElementById("status");

      this.realTimeCanvas = document.getElementById("fft-canvas");
      this.realTimeCtx = this.realTimeCanvas.getContext("2d");

      this.fullFileCanvas = document.getElementById("line-fft-canvas");
      this.fullFileCtx = this.fullFileCanvas.getContext("2d");

      this.plateTuningButton = document.getElementById("plate-tuning-button");
      this.plateTuningResetButton = document.getElementById(
        "plate-tuning-reset-button"
      );
      this.plateTuningDoneButton = document.getElementById(
        "plate-tuning-done-button"
      );
      this.frequencyGeneratorButton = document.getElementById(
        "frequency-generator-button"
      );

      this.frequencyTableBody = document.querySelector(
        "#frequency-table tbody"
      );
      this.clearLabelsButton = document.getElementById("clear-labels-button");

      this.audioController = null;
      this.cursorX = null;
      this.cursorY = null;
      this.currentFrequency = null;
      this.currentDb = null;
      this.labels = [];

      this.config = UIConfig;
      //this.transportControls = new TransportControls(this.realTimeCtx, this.config);

      // Frequency generator State
      this.isFrequencyGeneratorMode = false;

      // Plate Tuning Mode State
      this.isPlateTuningMode = false;

      this.plateTuningStep = 0;
      this.selectedPeaks = {
        long: null,
        cross: null,
        twisting: null,
      };

      this.resizeCanvases();
      this.handleResize();
    }

    initEventListeners(audioController, fftAnalyzer) {
      this.openButton.addEventListener("click", () => this.fileInput.click());
      this.fileInput.addEventListener("change", (e) =>
        audioController.loadFile(e)
      );
      this.playButton.addEventListener("click", () => audioController.play());
      this.stopButton.addEventListener("click", () => audioController.stop());
      this.recordButton.addEventListener("click", () =>
        audioController.toggleRecording()
      );
      this.saveButton.addEventListener("click", () =>
        audioController.saveCurrentAudio()
      );

      this.clearLabelsButton.addEventListener("click", () =>
        this.clearLabels()
      );

      this.audioController = audioController;

      // Frequency Generator
      this.frequencyGeneratorButton.addEventListener("click", () => {
        this.toggleFrequencyGeneratorMode(audioController);
      });

      // Plate Tuning Buttons
      this.plateTuningButton.addEventListener("click", () =>
        this.togglePlateTuningMode()
      );
      this.plateTuningResetButton.addEventListener("click", () =>
        this.resetPlateTuningSelections()
      );
      this.plateTuningDoneButton.addEventListener("click", () =>
        this.exitPlateTuningMode()
      );

      this.fullFileCanvas.addEventListener("mousemove", (e) =>
        fftAnalyzer.handleMouseMove(e, this)
      );
      this.fullFileCanvas.addEventListener("mouseleave", () =>
        fftAnalyzer.clearCursor(this)
      );
      this.fullFileCanvas.addEventListener("click", (e) => {
        if (
          this.isPlateTuningMode &&
          this.plateTuningStep > 0 &&
          this.plateTuningStep <= 3
        ) {
          fftAnalyzer.handleCanvasClick(e, this, true);
        } else {
          fftAnalyzer.handleCanvasClick(e, this, false);
        }
      });
    }
    // After a frequency is clicked, you will call this to update the table
    updateFrequencyTable() {
      // Clear existing rows
      while (this.frequencyTableBody.firstChild) {
        this.frequencyTableBody.removeChild(this.frequencyTableBody.firstChild);
      }

      // Populate rows for each label
      this.labels.forEach((label) => {
        const tr = document.createElement("tr");
        tr.style.borderBottom = "1px solid #555";

        const labelCell = document.createElement("td");
        labelCell.style.padding = "5px";
        labelCell.textContent = label.type || ""; // If in plate tuning mode, will have 'Long', 'Cross', or 'Twisting'

        const freqCell = document.createElement("td");
        freqCell.style.padding = "5px";
        freqCell.textContent = label.frequency;

        const dbCell = document.createElement("td");
        dbCell.style.padding = "5px";
        dbCell.textContent = label.dB;

        const noteCell = document.createElement("td");
        noteCell.style.padding = "5px";
        noteCell.textContent = label.note;
        
        const qCell = document.createElement("td");
        qCell.style.padding = "5px";
        qCell.textContent = label.Q ? label.Q.toFixed(2) : "";


        tr.appendChild(labelCell);
        tr.appendChild(freqCell);
        tr.appendChild(dbCell);
        tr.appendChild(noteCell);
        tr.appendChild(qCell);

        this.frequencyTableBody.appendChild(tr);
      });
    }

    clearLabels() {
      // Reset the labels array and plate tuning selections
      this.labels = [];
      this.selectedPeaks = { long: null, cross: null, twisting: null };
      this.plateTuningStep = 1; // Resetting to first step if needed
      this.updateUIForPlateTuning(); // Refresh UI status if you're in plate tuning mode
      this.updateFrequencyTable();
    }

    toggleFrequencyGeneratorMode(audioController) {
      this.isFrequencyGeneratorMode = !this.isFrequencyGeneratorMode;
      if (this.isFrequencyGeneratorMode) {
        this.setStatus("Frequency Generator Mode: ON");
        audioController.startFrequencyGenerator();
      } else {
        this.setStatus("Frequency Generator Mode: OFF");
        audioController.stopFrequencyGenerator();
      }
    }

    togglePlateTuningMode() {
      this.isPlateTuningMode = !this.isPlateTuningMode;
      if (this.isPlateTuningMode) {
        this.plateTuningStep = 1;
        this.plateTuningResetButton.style.display = "inline-block";
        this.updateUIForPlateTuning();
      } else {
        this.exitPlateTuningMode();
      }
    }

    resetPlateTuningSelections() {
      this.selectedPeaks = { long: null, cross: null, twisting: null };
      this.plateTuningStep = 1;
      this.labels = [];
      this.updateUIForPlateTuning();
    }

    exitPlateTuningMode() {
      this.isPlateTuningMode = false;
      this.plateTuningStep = 0;
      this.plateTuningResetButton.style.display = "none";
      this.plateTuningDoneButton.style.display = "none";
      this.setStatus("Exited Plate Tuning Mode");
      this.drawBaseUI();

      // Check if we have all three frequencies
      if (
        this.selectedPeaks.long &&
        this.selectedPeaks.cross &&
        this.selectedPeaks.transverse
      ) {
        const baseURL =
          "https://www.celestialinstruments.com/blogs/calculators/thickness-calculator";
        const url = `${baseURL}?long=${encodeURIComponent(
          this.selectedPeaks.long
        )}&cross=${encodeURIComponent(
          this.selectedPeaks.cross
        )}&twisting=${encodeURIComponent(this.selectedPeaks.transverse)}`;

        const linkContainer = document.getElementById(
          "frequency-table-container"
        );
        if (linkContainer) {
          // Remove old link if it exists
          const oldLink = linkContainer.querySelector(".calc-link");
          if (oldLink) oldLink.remove();

          const link = document.createElement("a");
          link.href = url;
          link.textContent =
            "Open Thickness Calculator with Selected Frequencies";
          link.style.color = "lightblue";
          link.style.display = "block";
          link.style.marginTop = "10px";
          link.className = "calc-link";
          linkContainer.appendChild(link);
        }
      }
    }

    updateUIForPlateTuning() {
      if (!this.isPlateTuningMode) return;

      switch (this.plateTuningStep) {
        case 1:
          this.setStatus("Plate Tuning: Select the Long Frequency Peak");
          break;
        case 2:
          this.setStatus("Plate Tuning: Select the Cross Frequency Peak");
          break;
        case 3:
          this.setStatus("Plate Tuning: Select the Twisting Frequency Peak");
          break;
        default:
          this.setStatus("All peaks selected. Press Done.");
      }

      if (this.plateTuningStep > 3) {
        this.plateTuningDoneButton.style.display = "inline-block";
      } else {
        this.plateTuningDoneButton.style.display = "none";
      }

      this.drawBaseUI();
    }

    setStatus(text) {
      this.statusDisplay.textContent = text;
    }

    setFileName(name) {
      this.fileNameDisplay.textContent = name;
    }

    clearCanvas(ctx, width, height, color = this.config.BACKGROUND_COLOR) {
      ctx.fillStyle = color;
      ctx.fillRect(0, 0, width, height);
    }

    drawBaseUI() {
      const ctx = this.realTimeCtx;
      const w = this.realTimeCanvas.width;
      const h = this.realTimeCanvas.height;

      this.clearCanvas(ctx, w, h);

      ctx.fillStyle = this.config.TEXT_COLOR;
      ctx.font = "14px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "top"; // Align text from its top

      if (this.isPlateTuningMode) {
        let instruction = "";
        if (this.plateTuningStep === 1) {
          instruction = "Select Long Frequency Peak";
        } else if (this.plateTuningStep === 2) {
          instruction = "Select Cross Frequency Peak";
        } else if (this.plateTuningStep === 3) {
          instruction = "Select Twisting Frequency Peak";
        } else if (this.plateTuningStep > 3) {
          instruction = "All peaks selected. Press Done.";
        }
        ctx.fillText("Plate Tuning Mode: " + instruction, w / 2, 60);
      }

      if (this.currentFrequency !== null && this.currentDb !== null) {
        ctx.fillText(
          `Frequency: ${this.currentFrequency.toFixed(2)} Hz`,
          w / 2,
          20
        );
        ctx.fillText(`dB: ${this.currentDb.toFixed(2)}`, w / 2, 40);
        const noteInfo = frequencyToNoteName(this.currentFrequency);
        ctx.fillText(`Note: ${noteInfo}`, w / 2, 60);
      } else {
        ctx.fillText(
          "Move the mouse over the graph",
          w / 2,
          this.isPlateTuningMode ? 130 : 40
        );
      }
    }

    resizeCanvases() {
      this.realTimeCanvas.width = this.realTimeCanvas.clientWidth;
      this.realTimeCanvas.height = this.realTimeCanvas.clientHeight;
      this.fullFileCanvas.width = this.fullFileCanvas.clientWidth;
      this.fullFileCanvas.height = this.fullFileCanvas.clientHeight;
    }

    handleResize() {
      let resizeTimeout;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.realTimeCanvas.width = this.realTimeCanvas.clientWidth;
          this.realTimeCanvas.height = this.realTimeCanvas.clientHeight;

          this.fullFileCanvas.width = this.fullFileCanvas.clientWidth;
          this.fullFileCanvas.height = this.fullFileCanvas.clientHeight;
        }, 200);
      });
    }

    resetCursorAndLabels() {
      this.cursorX = null;
      this.cursorY = null;
      this.currentFrequency = null;
      this.currentDb = null;
    }
  }
  function audioBufferToWav(audioBuffer) {
    const numOfChannels = audioBuffer.numberOfChannels;
    const sampleRate = audioBuffer.sampleRate;
    const samples = audioBuffer.length;

    // For simplicity, we'll handle 1 or 2 channels
    // Gather channel data
    const channelData = [];
    for (let i = 0; i < numOfChannels; i++) {
      channelData.push(audioBuffer.getChannelData(i));
    }

    const blockAlign = numOfChannels * 2;
    const byteRate = sampleRate * blockAlign;
    const buffer = new ArrayBuffer(44 + samples * blockAlign);
    const view = new DataView(buffer);

    // Helper to write strings to DataView
    function writeString(view, offset, string) {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    }

    // RIFF chunk descriptor
    writeString(view, 0, "RIFF");
    view.setUint32(4, 36 + samples * blockAlign, true);
    writeString(view, 8, "WAVE");

    // FMT sub-chunk
    writeString(view, 12, "fmt ");
    view.setUint32(16, 16, true); // SubChunk1Size (16 for PCM)
    view.setUint16(20, 1, true); // AudioFormat (1 = PCM)
    view.setUint16(22, numOfChannels, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, byteRate, true);
    view.setUint16(32, blockAlign, true);
    view.setUint16(34, 16, true); // Bits per sample

    // Data sub-chunk
    writeString(view, 36, "data");
    view.setUint32(40, samples * blockAlign, true);

    // Write the PCM samples
    let offset = 44;
    if (numOfChannels === 1) {
      // Mono: just write samples directly
      const input = channelData[0];
      for (let i = 0; i < samples; i++, offset += 2) {
        view.setInt16(offset, input[i] * 0x7fff, true);
      }
    } else if (numOfChannels === 2) {
      // Stereo: interleave left and right
      const left = channelData[0];
      const right = channelData[1];
      for (let i = 0; i < samples; i++) {
        view.setInt16(offset, left[i] * 0x7fff, true);
        offset += 2;
        view.setInt16(offset, right[i] * 0x7fff, true);
        offset += 2;
      }
    }

    return buffer;
  }

  class AudioController {
    constructor(ui) {
      this.ui = ui;
      this.audioContext = null;
      this.sourceNode = null;
      this.analyserNode = null;
      this.recordingAnalyserNode = null;
      this.audioBuffer = null;
      this.isPlaying = false;
      this.isRecording = false;
      this.mediaRecorder = null;
      this.recordedChunks = [];
      this.microphoneSourceNode = null;
      this.frequencyDataArray = null;
      this.frequencyBinCount = null;
      this.oscillator = null;
      this.oscGainNode = null;

      this.initializeInputDevices();
    }

    async initializeInputDevices() {
      try {
        await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: false,
        });
        const devices = await navigator.mediaDevices.enumerateDevices();
        const audioInputs = devices.filter((d) => d.kind === "audioinput");

        this.ui.audioInputSelect.innerHTML = "";
        audioInputs.forEach((device, index) => {
          const option = document.createElement("option");
          option.value = device.deviceId;
          option.text = device.label || `Microphone ${index + 1}`;
          this.ui.audioInputSelect.appendChild(option);
        });

        if (audioInputs.length > 0) {
          this.ui.audioInputSelect.value = audioInputs[0].deviceId;
          await this.populateChannelSelect(audioInputs[0].deviceId);
        }

        navigator.mediaDevices.ondevicechange = () =>
          this.initializeInputDevices();
      } catch (err) {
        console.error("Error accessing user media:", err);
        alert("Could not access the microphone. Please check permissions.");
      }
    }

    async populateChannelSelect(deviceId) {
      const select = this.ui.channelSelect;
      select.innerHTML = "";

      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: { deviceId: { exact: deviceId } },
          video: false,
        });

        const audioTrack = stream.getAudioTracks()[0];
        const capabilities = audioTrack.getCapabilities();
        let supportedCounts = [];

        if (capabilities.channelCount) {
          if (Array.isArray(capabilities.channelCount.values)) {
            supportedCounts = capabilities.channelCount.values;
          } else if (
            capabilities.channelCount.min &&
            capabilities.channelCount.max
          ) {
            for (
              let i = capabilities.channelCount.min;
              i <= capabilities.channelCount.max;
              i++
            ) {
              supportedCounts.push(i);
            }
          }
        }

        if (supportedCounts.length === 0) {
          supportedCounts = [1, 2];
        }

        supportedCounts = [...new Set(supportedCounts)].sort((a, b) => a - b);
        supportedCounts.forEach((count) => {
          const option = document.createElement("option");
          option.value = count;
          option.text = `${count} Channel${count > 1 ? "s" : ""}`;
          select.appendChild(option);
        });

        select.value = supportedCounts[0];
        stream.getTracks().forEach((t) => t.stop());
      } catch (err) {
        console.error("Error retrieving channel counts:", err);
        alert("Could not determine supported channel counts.");
        const option = document.createElement("option");
        option.value = 1;
        option.text = "Mono";
        select.appendChild(option);
        select.value = 1;
      }
    }

    loadFile(event) {
      const file = event.target.files[0];
      if (!file) {
        this.ui.setFileName("No file selected");
        alert("Please select a valid WAV file.");
        return;
      }

      const fileName = file.name.toLowerCase();
      if (!fileName.endsWith(".wav")) {
        this.ui.setFileName("No file selected");
        alert("Please select a valid WAV file.");
        return;
      }

      this.ui.setFileName(file.name);
      const reader = new FileReader();
      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        this.initializeAudio(arrayBuffer);
      };
      reader.readAsArrayBuffer(file);
    }

    initializeAudio(arrayBuffer) {
      if (this.audioContext) {
        this.audioContext.close();
      }
      this.audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      this.audioContext.decodeAudioData(
        arrayBuffer,
        (decodedData) => {
          this.audioBuffer = decodedData;
          this.initializeAnalyserNode();
          this.ui.drawBaseUI();
          requestAnimationFrame(() => this.drawRealTimeFFT());
          fftAnalyzer.computeAndDrawFullFileFFT(
            this.audioBuffer,
            this.audioContext
          );
          this.ui.setStatus("Audio loaded successfully!");
        },
        (error) => {
          console.error("Error decoding audio data:", error);
          alert("Failed to decode audio file.");
        }
      );
    }

    initializeAnalyserNode() {
      this.analyserNode = this.audioContext.createAnalyser();
      this.analyserNode.fftSize = 32768;
      this.frequencyBinCount = this.analyserNode.frequencyBinCount;
      this.frequencyDataArray = new Uint8Array(this.frequencyBinCount);
    }

    play() {
      if (!this.audioBuffer) {
        this.ui.setStatus("No audio loaded to play.");
        return;
      }
      if (this.isPlaying) {
        this.ui.setStatus("Already playing.");
        return;
      }
      this.sourceNode = this.audioContext.createBufferSource();
      this.sourceNode.buffer = this.audioBuffer;
      this.sourceNode.connect(this.analyserNode);
     // this.analyserNode.connect(this.audioContext.destination);
      this.sourceNode.start(0);
      this.isPlaying = true;
      this.ui.setStatus("Playing...");

      this.sourceNode.onended = () => {
        this.isPlaying = false;
        this.ui.setStatus("Playback finished.");
      };
    }

    stop() {
      if (this.isPlaying && this.sourceNode) {
        this.sourceNode.stop(0);
        this.isPlaying = false;
        this.ui.setStatus("Stopped.");
      }
    }

    async startRecording() {
      const deviceId = this.ui.audioInputSelect.value;
      const channelCount = parseInt(this.ui.channelSelect.value, 10) || 1;

      const constraints = {
        audio: {
          deviceId: deviceId ? { exact: deviceId } : undefined,
          channelCount: channelCount,
          echoCancellation: false,
          noiseSuppression: false,
          autoGainControl: false,
        },
        video: false,
      };

      try {
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        this.mediaRecorder = new MediaRecorder(stream);
        this.recordedChunks = [];

        this.mediaRecorder.ondataavailable = (e) => {
          if (e.data.size > 0) {
            this.recordedChunks.push(e.data);
          }
        };

        this.mediaRecorder.onstop = () => {
          const blob = new Blob(this.recordedChunks, { type: "audio/webm" });
          const reader = new FileReader();
          reader.onload = (e) => {
            const arrayBuffer = e.target.result;
            this.initializeAudio(arrayBuffer);
            this.ui.setStatus("Recording completed and loaded.");
          };
          reader.readAsArrayBuffer(blob);
        };

        this.mediaRecorder.start();
        this.isRecording = true;
        this.ui.recordButton.textContent = "Stop Recording";
        this.ui.setStatus("Recording...");

        this.ui.resetCursorAndLabels();

        this.microphoneSourceNode =
          this.audioContext.createMediaStreamSource(stream);
        this.recordingAnalyserNode = this.audioContext.createAnalyser();
        this.recordingAnalyserNode.fftSize = 32768;

        this.microphoneSourceNode.connect(this.recordingAnalyserNode);
        //this.recordingAnalyserNode.connect(this.audioContext.destination);
      } catch (err) {
        console.error("Error accessing user media:", err);
        alert("Could not access the microphone. Please check permissions.");
      }
    }

    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
        this.ui.recordButton.textContent = "Record";
        this.ui.setStatus("Processing recording...");

        if (this.microphoneSourceNode && this.recordingAnalyserNode) {
          this.microphoneSourceNode.disconnect(this.recordingAnalyserNode);
          this.recordingAnalyserNode.disconnect(this.audioContext.destination);
          this.microphoneSourceNode = null;
          this.recordingAnalyserNode = null;
        }
      }
    }

    toggleRecording() {
      if (this.isRecording) {
        this.stopRecording();
      } else {
        this.startRecording();
      }
    }

    drawRealTimeFFT() {
      requestAnimationFrame(() => this.drawRealTimeFFT());
      const ctx = this.ui.realTimeCtx;
      const canvas = this.ui.realTimeCanvas;
      const width = canvas.width;
      const height = canvas.height;

      this.ui.clearCanvas(ctx, width, height);
      this.ui.drawBaseUI();

      let currentAnalyser = null;
      if (this.isRecording && this.recordingAnalyserNode) {
        currentAnalyser = this.recordingAnalyserNode;
      } else if (this.analyserNode) {
        currentAnalyser = this.analyserNode;
      }

      if (!currentAnalyser) return;

      if (this.isRecording && this.recordingAnalyserNode) {
        const fftSize = currentAnalyser.fftSize;
        const timeDomainData = new Float32Array(fftSize);
        currentAnalyser.getFloatTimeDomainData(timeDomainData);

        const doublePrecisionData = new Float64Array(timeDomainData);
        const windowFunction = new WindowFunction(DSP.HAMMING);
        windowFunction.process(doublePrecisionData);

        const fft = new FFT(fftSize, this.audioContext.sampleRate);
        fft.forward(doublePrecisionData);

        const sampleRate = this.audioContext.sampleRate;
        const nyquist = sampleRate / 2;
        const binWidth = nyquist / (fftSize / 2);
        const minFreq = 20;
        const maxFreq = 1000;
        const minIndex = Math.floor(minFreq / binWidth);
        const maxIndex = Math.floor(maxFreq / binWidth);

        fftAnalyzer.frequenciesSlice = new Float32Array(
          maxIndex - minIndex + 1
        );
        fftAnalyzer.magnitudesSlice = new Float32Array(maxIndex - minIndex + 1);

        for (let i = minIndex, j = 0; i <= maxIndex; i++, j++) {
          fftAnalyzer.frequenciesSlice[j] = i * binWidth;
          const magnitude = Math.max(fft.spectrum[i], 1e-10);
          let dbValue = 20 * Math.log10(magnitude);
          fftAnalyzer.magnitudesSlice[j] = dbValue;
        }

        fftAnalyzer.drawFullFileFFTLinePlot(this.ui.cursorX, this.ui.cursorY);
      } else {
        const dataArray = new Uint8Array(currentAnalyser.frequencyBinCount);
        currentAnalyser.getByteFrequencyData(dataArray);

        const barWidth = (width / currentAnalyser.frequencyBinCount) * 2.5;
        let x = 0;
        for (let i = 0; i < currentAnalyser.frequencyBinCount; i++) {
          const barHeight = dataArray[i];
          const r = barHeight + 55 * (i / currentAnalyser.frequencyBinCount);
          const g = 250 * (i / currentAnalyser.frequencyBinCount);
          const b = 50;

          ctx.fillStyle = `rgb(${r},${g},${b})`;
          ctx.fillRect(x, height - barHeight / 2, barWidth, barHeight / 2);
          x += barWidth + 1;
        }

        this.ui.drawBaseUI();
      }
    }

    saveCurrentAudio() {
      if (!this.audioBuffer) {
        this.ui.setStatus("No audio loaded to save.");
        return;
      }

      const wavBuffer = audioBufferToWav(this.audioBuffer);
      const blob = new Blob([new DataView(wavBuffer)], { type: "audio/wav" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = "exported.wav";
      document.body.appendChild(a);
      a.click();

      URL.revokeObjectURL(url);
      a.remove();
      this.ui.setStatus("Audio saved locally.");
    }

    startFrequencyGenerator() {
      if (!this.audioContext) {
        this.audioContext = new (window.AudioContext ||
          window.webkitAudioContext)();
      }

      // Create an oscillator and a gain node to control its volume
      this.oscillator = this.audioContext.createOscillator();
      this.oscGainNode = this.audioContext.createGain();

      this.oscillator.type = "sine";
      this.oscillator.frequency.setValueAtTime(
        440,
        this.audioContext.currentTime
      ); // default to A4
      this.oscGainNode.gain.setValueAtTime(0.1, this.audioContext.currentTime); // a gentle volume

      this.oscillator.connect(this.oscGainNode);
      this.oscGainNode.connect(this.audioContext.destination);

      this.oscillator.start();
    }

    stopFrequencyGenerator() {
      if (this.oscillator) {
        this.oscillator.stop();
        this.oscillator.disconnect();
        this.oscGainNode.disconnect();
        this.oscillator = null;
        this.oscGainNode = null;
      }
    }

    updateFrequencyGenerator(freq) {
      if (this.oscillator) {
        this.oscillator.frequency.setValueAtTime(
          freq,
          this.audioContext.currentTime
        );
      }
    }
  }

  class FFTAnalyzer {
    constructor(ui) {
      this.ui = ui;
      this.frequenciesSlice = [];
      this.magnitudesSlice = [];
    }
    computeAndDrawFullFileFFT2(audioBuffer, audioContext) {
      if (!audioBuffer) return;
    
      const fs      = audioContext.sampleRate;
      const data    = audioBuffer.getChannelData(0);
    
      const fftSize = Math.min(16384, 1 << Math.floor(Math.log2(data.length))); // ≤16k
      const block   = data.slice(0, fftSize);   // first window
    
      hannWindow(block);                        // ← new taper
      const fft  = new FFT(fftSize, fs);
      fft.forward(block);
    
      const binW = fs / fftSize;                // same as nyquist/(N/2)
      const half = fftSize >> 1;
    
      // Fill the arrays graph-code expects
      this.frequenciesSlice = new Float32Array(half);
      this.magnitudesSlice  = new Float32Array(half);
    
      for (let i = 0; i < half; i++) {
        this.frequenciesSlice[i] = i * binW;
        this.magnitudesSlice[i]  = fft.spectrum[i];        // linear mag
      }
    
      this.drawFullFileFFTLinePlot();
    }
    computeAndDrawFullFileFFT(audioBuffer, audioContext) {
      if (!audioBuffer) {
        console.error("No audio buffer loaded.");
        return;
      }

      const leftChannelData = audioBuffer.getChannelData(0);
      const sampleRate = audioContext.sampleRate;
      const fftSize = Math.pow(
        2,
        Math.floor(Math.log2(leftChannelData.length))
      );
      const nyquist = sampleRate / 2;
      const binWidth = nyquist / (fftSize / 2);

      const fftInputData = leftChannelData.slice(0, fftSize);
      const windowedData = this.applyHammingWindow(fftInputData);

      const fft = new FFT(fftSize, sampleRate);
      fft.forward(windowedData);

      const rawSpectrum = fft.spectrum;
      const smoothedSpectrum = this.applyGaussianSmoothing(rawSpectrum, 8);

      const frequencyValues = new Float32Array(fftSize / 2);
      for (let i = 0; i < frequencyValues.length; i++) {
        frequencyValues[i] = i * binWidth;
      }

      const [minFreq, maxFreq] = [20, 1000];
      const minIndex = Math.ceil(minFreq / binWidth);
      const maxIndex = Math.floor(maxFreq / binWidth);

      this.frequenciesSlice = frequencyValues.slice(minIndex, maxIndex + 1);
      this.magnitudesSlice = smoothedSpectrum.slice(minIndex, maxIndex + 1);

      this.drawFullFileFFTLinePlot();
    }

    applyHammingWindow(buffer) {
      return buffer.map(
        (sample, index) =>
          sample *
          (0.54 - 0.46 * Math.cos((2 * Math.PI * index) / (buffer.length - 1)))
      );
    }

    applyGaussianSmoothing(data, sigma = 2) {
      const kernelSize = Math.ceil(sigma * 3) * 2 + 1;
      const kernel = new Float32Array(kernelSize);
      const halfSize = Math.floor(kernelSize / 2);
      let sum = 0;

      for (let i = -halfSize; i <= halfSize; i++) {
        const value = Math.exp(-(i * i) / (2 * sigma * sigma));
        kernel[i + halfSize] = value;
        sum += value;
      }

      for (let i = 0; i < kernelSize; i++) {
        kernel[i] /= sum;
      }

      const smoothedData = new Float32Array(data.length);
      for (let i = 0; i < data.length; i++) {
        let value = 0;
        for (let j = -halfSize; j <= halfSize; j++) {
          const index = i + j;
          if (index >= 0 && index < data.length) {
            value += data[index] * kernel[j + halfSize];
          }
        }
        smoothedData[i] = value;
      }

      return smoothedData;
    }

    drawFullFileFFTLinePlot(cursorX = null, cursorY = null) {
      const ctx = this.ui.fullFileCtx;
      const canvas = this.ui.fullFileCanvas;
      const w = canvas.width;
      const h = canvas.height;

      this.ui.clearCanvas(ctx, w, h);

      this.drawFrequencyAxis();
      this.drawDecibelAxis(-100, -40);

      const magnitudesInDB = this.magnitudesSlice.map((mag) => {
        const magnitude = Math.max(mag, 1e-10);
        let dbValue = 20 * Math.log10(magnitude);
        return Math.max(dbValue, -100);
      });

      ctx.strokeStyle = "#00ff00";
      ctx.lineWidth = 2;
      ctx.beginPath();

      const sliceWidth =
        (w - this.ui.config.LEFT_PADDING) / magnitudesInDB.length;
      let x = this.ui.config.LEFT_PADDING;

      for (let i = 0; i < magnitudesInDB.length; i++) {
        const dbValue = magnitudesInDB[i];
        const y = ((-40 - dbValue) / (-40 + 100)) * h;
        i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
        x += sliceWidth;
      }
      ctx.stroke();

      if (cursorX !== null && cursorY !== null) {
        this.drawCursor(cursorX, cursorY);
      }

      this.drawLabels();
    }

    drawDecibelAxis(minDB, maxDB) {
      const ctx = this.ui.fullFileCtx;
      const h = this.ui.fullFileCanvas.height;
      const leftPadding = this.ui.config.LEFT_PADDING;
      ctx.font = this.ui.config.AXIS_FONT;
      ctx.fillStyle = "#FFFFFF";
      ctx.strokeStyle = "#FFFFFF";
      ctx.lineWidth = 1;

      const numTicks = 5;
      const tickSpacing = h / numTicks;

      for (let i = 0; i <= numTicks; i++) {
        const y = i * tickSpacing;
        const dbValue = maxDB - (i / numTicks) * (maxDB - minDB);

        ctx.beginPath();
        ctx.moveTo(leftPadding - 5, y);
        ctx.lineTo(leftPadding, y);
        ctx.stroke();

        ctx.fillText(`${dbValue.toFixed(0)} dB`, 5, y + 5);
      }
    }

    drawFrequencyAxis() {
      const ctx = this.ui.fullFileCtx;
      const w = this.ui.fullFileCanvas.width;
      const h = this.ui.fullFileCanvas.height;
      const leftPadding = this.ui.config.LEFT_PADDING;
      const bottomPadding = this.ui.config.BOTTOM_PADDING;

      ctx.font = this.ui.config.FREQUENCY_FONT;
      ctx.fillStyle = "#FFFFFF";
      ctx.strokeStyle = "#FFFFFF";
      ctx.lineWidth = 1;

      const numTicks = 10;
      const tickSpacing = (w - leftPadding) / numTicks;

      for (let i = 0; i <= numTicks; i++) {
        const x = leftPadding + i * tickSpacing;
        const freqIndex = Math.floor(
          (i / numTicks) * this.frequenciesSlice.length
        );
        const freq =
          freqIndex < this.frequenciesSlice.length
            ? this.frequenciesSlice[freqIndex].toFixed(0)
            : "";

        ctx.beginPath();
        ctx.moveTo(x, h - bottomPadding);
        ctx.lineTo(x, h - bottomPadding + 5);
        ctx.stroke();

        ctx.fillText(`${freq} Hz`, x - 10, h - 5);
      }
    }

    drawCursor(cursorX, cursorY) {
      const ctx = this.ui.fullFileCtx;
      const h = this.ui.fullFileCanvas.height;

      ctx.strokeStyle = "red";
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(cursorX, 0);
      ctx.lineTo(cursorX, h);
      ctx.stroke();

      ctx.fillStyle = "red";
      ctx.beginPath();
      ctx.arc(cursorX, cursorY, 5, 0, 2 * Math.PI);
      ctx.fill();
    }

    drawLabels() {
      const ctx = this.ui.fullFileCtx;
      this.ui.labels.forEach((label) => {
        const { x, y, frequency, dB, note } = label;
        ctx.fillStyle = "blue";
        ctx.beginPath();
        ctx.arc(x, y, 5, 0, 2 * Math.PI);
        ctx.fill();

        const labelText = `${frequency} Hz, ${note}`;
        ctx.font = this.ui.config.LABEL_FONT;
        const textWidth = ctx.measureText(labelText).width;
        const padding = 4;

        ctx.fillStyle = "rgba(0, 0, 0, 0.7)";
        ctx.fillRect(
          x - textWidth / 2 - padding,
          y - 25,
          textWidth + padding * 2,
          20
        );

        ctx.fillStyle = "white";
        ctx.textAlign = "center";
        ctx.fillText(labelText, x, y - 10);
      });
    }

    handleMouseMove(event, ui) {
      const rect = ui.fullFileCanvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const availableWidth = ui.fullFileCanvas.width - ui.config.LEFT_PADDING;
      const relativeX = x - ui.config.LEFT_PADDING;

      if (!this.isWithinPlot(relativeX, availableWidth)) {
        this.clearCursor(ui);
        return;
      }

      const index = this.xToIndex(
        relativeX,
        availableWidth,
        this.frequenciesSlice.length
      );
      if (index < 0 || index >= this.frequenciesSlice.length) {
        this.clearCursor(ui);
        return;
      }

      const dbValue =
        20 * Math.log10(Math.max(this.magnitudesSlice[index], 1e-10));
      const y = ((-40 - dbValue) / (-40 + 100)) * ui.fullFileCanvas.height;

      ui.cursorX =
        ui.config.LEFT_PADDING +
        index * (availableWidth / this.frequenciesSlice.length);
      ui.cursorY = y;
      ui.currentFrequency = this.frequenciesSlice[index];
      ui.currentDb = dbValue;

      this.drawFullFileFFTLinePlot(ui.cursorX, ui.cursorY);
      ui.drawBaseUI();

      if (ui.isFrequencyGeneratorMode && ui.audioController) {
        ui.audioController.updateFrequencyGenerator(ui.currentFrequency);
      }
    }

    handleCanvasClick(event, ui, isPlateTuningClick = false) {
      const rect = ui.fullFileCanvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const availableWidth = ui.fullFileCanvas.width - ui.config.LEFT_PADDING;
      const relativeX = x - ui.config.LEFT_PADDING;

      if (!this.isWithinPlot(relativeX, availableWidth)) return;

      const index = this.xToIndex(
        relativeX,
        availableWidth,
        this.frequenciesSlice.length
      );
      if (index < 0 || index >= this.frequenciesSlice.length) return;

      const frequency = this.frequenciesSlice[index].toFixed(2);
      const dbValue = (
        20 * Math.log10(Math.max(this.magnitudesSlice[index], 1e-10))
      ).toFixed(2);
      const noteName = frequencyToNoteName(frequency);

      const exactX =
        ui.config.LEFT_PADDING +
        index * (availableWidth / this.frequenciesSlice.length);
      const y = ui.cursorY;

      let labelData = { x: exactX, y, frequency, dB: dbValue, note: noteName };

      // If in Plate Tuning Mode and user is selecting peaks
      if (
        isPlateTuningClick &&
        ui.isPlateTuningMode &&
        ui.plateTuningStep > 0 &&
        ui.plateTuningStep <= 3
      ) {
        let type = "";
        if (ui.plateTuningStep === 1) {
          type = "Long";
          ui.selectedPeaks.long = frequency;
        } else if (ui.plateTuningStep === 2) {
          type = "Cross";
          ui.selectedPeaks.cross = frequency;
        } else if (ui.plateTuningStep === 3) {
          type = "Transverse";
          ui.selectedPeaks.transverse = frequency;
        }

        ui.labels.push({ x: exactX, y, frequency, dB: dbValue, note: noteName, type });
        ui.plateTuningStep++;
        ui.updateUIForPlateTuning();
      } else {
        ui.labels.push(labelData);
        this.drawFullFileFFTLinePlot(ui.cursorX, ui.cursorY);
      }

      // Update the frequency table after adding a new label
      ui.updateFrequencyTable();
    }

    clearCursor(ui) {
      ui.cursorX = null;
      ui.cursorY = null;
      ui.currentFrequency = null;
      ui.currentDb = null;
      this.drawFullFileFFTLinePlot();
      ui.drawBaseUI();
      // If frequency generator mode is on, set the frequency to 0
      if (ui.isFrequencyGeneratorMode && ui.audioController) {
        ui.audioController.updateFrequencyGenerator(0);
      }
    }

    isWithinPlot(relativeX, availableWidth) {
      return relativeX >= 0 && relativeX <= availableWidth;
    }

    xToIndex(relativeX, availableWidth, length) {
      const sliceWidth = availableWidth / length;
      return Math.floor(relativeX / sliceWidth);
    }
  }

  const ui = new UIController();
  const fftAnalyzer = new FFTAnalyzer(ui);
  const audioController = new AudioController(ui);
  ui.initEventListeners(audioController, fftAnalyzer);
});
